import React, { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { updatePlanRoom, updatePreQualify } from "../../store/actions/gc_qualify/gcQualify.actions";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { updateProjectNotes } from "../../store/actions/projects/projects.action";
import { useFeatureAccess } from "../../hooks/useFeatureAccess";
const StyledTextArea = styled(Form.Control)`
  @media (max-width: 576px) {
    width: 110px;
  }
`;

const NotesContainer = ({
  row,
  handleSetLoginModal,
  handleSetPaymentModal,
  handleSetFreeMode,
  price_id,
  free_mode_count,
  user,
  view,
  widthLg,
  fullWidth,
}) => {
  const [note, setNote] = useState(row?.max_note || row?.project_notes);
  const [showButton, setShowButton] = useState(false);
  const { loading } = useSelector((state) => state.planRoomUpdate);
  const { loading2 } = useSelector((state) => state.preQualifyUpdate);
  const { loadingNotes } = useSelector((state) => state.projects);
  const requiredFeature = view === "project"
    ? "Project"
    : window.location.pathname?.includes("/plan_room")
      ? "Planroom"
      : "Prequalify";
  const { hasFeatureAccess, enforceAccess } = useFeatureAccess(requiredFeature);
  const boxRef = useRef();
  const dispatch = useDispatch();

  const handleNoteClick = (e) => {
    setNote(e.target.value);
    setShowButton(true);
  };

  const handleSaveNote = () => {
    if (!user) {
      handleSetLoginModal();
    } else if (!hasFeatureAccess) {
      enforceAccess();
    } else {
      handleSetFreeMode();
      if (note !== "") {
        if (view == "planroom"){
          dispatch(updatePlanRoom({ note, company_account_id: row.id }));

        } else if (view == 'gcqualify'){
          dispatch(updatePreQualify({ note, company_account_id: row.id }));
        } else if (view == 'project') {
          dispatch(updateProjectNotes(note, row.id));
        }
      }
      setShowButton(false);
    }
  };

  return (
    <div className={fullWidth ? "d-flex flex-column gap-2 w-100" : undefined}>
      <StyledTextArea
        id={row.id}
        as="textarea"
        rows={fullWidth ? 4 : note ? "3" : "1"}
        key={row.id}
        value={note || ""}
        onChange={(e) => handleNoteClick(e)}
        style={
          fullWidth
            ? { width: "100%", resize: "none", height: "72px", overflowY: "auto" }
            : widthLg
            ? { width: "70%" }
            : {}
        }
        placeholder={fullWidth ? "Add notes about this project..." : undefined}
      />
      {showButton && (
        <Button
          type="submit"
          variant="primary"
          className={fullWidth ? "align-self-start px-4 py-2" : "p-3 col-md-3"}
          onClick={handleSaveNote}
          disabled={loading || loading2}
        >
          Save
          {(loading || loading2 || loadingNotes) && (
            <span
              className="spinner-border spinner-border-sm ms-2"
              role="status"
              aria-hidden="true"
            ></span>
          )}
          <span className="visually-hidden">Loading...</span>
        </Button>
      )}
    </div>
  );
};

export default NotesContainer;
